/**
 * Transcription Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.1.21
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ResourceRequest { 
    type: ResourceRequest.TypeEnum;
    filename: string;
    contentType: string;
    fileSize?: number;
}
export namespace ResourceRequest {
    export type TypeEnum = 'TRANSCRIPTION';
    export const TypeEnum = {
        TRANSCRIPTION: 'TRANSCRIPTION' as TypeEnum
    };
}